export default {
  props: {
    titulo: {
      type: String,
      default: 'Título',
    },
  },
  data() {
    return {
      visible: false,
      datos: null,
    };
  },
  methods: {
    rellenarDatos(datos) {
      return datos;
    },
    abrirMixin(datos) {
      this.datos = this.rellenarDatos(datos);
      this.visible = true;
    },
    cerrar() {
      this.visible = false;
    },
  },
};
